module.exports = __webpack_public_path__ + "static/media/logo-camarabrejo.80c62caa.png";